import { render, staticRenderFns } from "./ModalEnderecoEletronico.vue?vue&type=template&id=b834d496&scoped=true"
import script from "./ModalEnderecoEletronico.vue?vue&type=script&lang=js"
export * from "./ModalEnderecoEletronico.vue?vue&type=script&lang=js"
import style0 from "./ModalEnderecoEletronico.vue?vue&type=style&index=0&id=b834d496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b834d496",
  null
  
)

export default component.exports